import { sanitizeNext } from "../sanitize-next";

/**
 * Validates a returnUrl to prevent open redirect attacks.
 * Only allows non-auth relative paths starting with '/'.
 * Rejects: absolute URLs, protocol-relative URLs (//evil.com), javascript: URIs,
 * auth/login loops, backslash bypasses, encoded double-slashes, and CRLF injection.
 */
export function validateReturnUrl(url: string | null): string {
  // Keep one authoritative policy for player/platform returnUrl and business
  // next destinations. The fallback is local, public, and loop-free.
  return sanitizeNext(url) ?? "/";
}
